module.exports = __webpack_public_path__ + "static/media/S (173).14aaaa48.jpg";